"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

var _iconMap = require("../utils/icon-map"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _default = {
  data: function data() {
    return {
      section: '',
      isActive: false,
      icons: _iconMap.icons
    };
  },
  props: {
    isSynced: Boolean,
    name: String,
    description: String,
    showHero: Boolean
  },
  mounted: function mounted() {
    var _this = this;

    this.isActive = window.location.hash.replace('#', '') === this.name.toLowerCase().replace(' ', '-');
    this.$root.$on('updateView', function (title) {
      _this.isActive = _this.name === title;
    });
    this.section = this.$parent.$props.name;
  }
};
exports["default"] = _default;